import React,{useEffect,useState} from 'react';
import {Link} from 'react-router-dom';

const key='technoration-welcome-seen';
export default function WelcomePrompt(){
  const [open,setOpen]=useState(false);
  useEffect(()=>{
    if(localStorage.getItem(key)) return;
    const timer=window.setTimeout(()=>{localStorage.setItem(key,'1');setOpen(true)},3000);
    return()=>window.clearTimeout(timer);
  },[]);
  if(!open) return null;
  return <div className="welcome-overlay" onMouseDown={event=>{if(event.target===event.currentTarget)setOpen(false)}}><section className="welcome-dialog" role="dialog" aria-modal="true" aria-labelledby="welcome-title"><button className="welcome-close" type="button" aria-label="Close welcome message" onClick={()=>setOpen(false)}>×</button><span className="eyebrow">LET'S CONNECT</span><h2 id="welcome-title">Welcome to Technoration Limited</h2><p>Have a project proposal or need technical consultation? Tell us what you are working on, and our team will get in touch.</p><div className="actions"><Link className="button button-primary" to="/proposal" onClick={()=>setOpen(false)}>Send a proposal</Link><Link className="button button-outline" to="/consultation" onClick={()=>setOpen(false)}>Request consultation</Link></div></section></div>;
}
